import { IReducersMap, reducer } from '../../standard-actions/reducers';
import {
    ORDER_TRACKER_LOAD_ORDERS,
    ORDER_TRACKER_SORT_ORDERS,
    ORDER_TRACKER_LOAD_ORDER_DETAILS,
    ORDER_TRACKER_LOAD_ORDER_INFO,
    ORDER_TRACKER_LOAD_ORDER_PRODUCT_DETAILS,
    ORDER_TRACKER_LOAD_ORDER_INFO_RESET,
    ORDER_TRACKER_SEARCH_ORDER_DETAILS_SUMMARY,
    ORDER_TRACKER_UPDATE_SEARCH_ORDERS,
    ORDER_TRACKER_UPDATE_SEARCH_ORDER_DETAILS_SUMMARY,
    ORDER_TRACKER_LOAD_SUMMARY,
    ORDER_TRACKER_UPDATE_SELECTED_PRODUCT,
    ORDER_TRACKER_UPDATE_SELECTED_PRODUCT_TEMP,
    ORDER_TRACKER_DOWNLOAD_CSV,
    ORDER_TRACKER_DETAIL_UPDATE_VIEW_BY,
    ORDER_TRACKER_LOAD_PAGINATION,
    ORDER_TRACKER_SELECT_COLUMNS,
    ORDER_TRACKER_ORDER_EXPRESS_FLAG,
    ORDER_TRACKER_ACTIVE_TAB,
    ORDER_TRACKER_UPDATE_ORDER_TABS,
    ORDER_TRACKER_UPDATE_ORDER_REFERENCE,
    ORDER_TRACKER_DETAIL_UPDATE_ACCEPTANCE_STATUS,
    ORDER_TRACKER_LOAD_APPOINTMENT_DATE,
    SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE_INT,
    ORDER_TRACKER_LOAD_ORDERS_INT_V2,
    ORDER_TRACKER_INT_LIST_UPDATE,
    ORDER_TRACKER_UPDATE_SEARCH_ORDERS_INT_V2,
    ORDER_TRACKER_UPDATE_ORDER_REFERENCE_LOCALLY,
    ORDER_TRACKER_DOWNLOAD_PRODUCT_LIST,
    ORDER_TRACKER_PRODUCT_ORDERS_LIST
} from '../actions/action-types';
import { IOrderTrackerState } from '../state';
import { initialState } from '../state/initial-state';
import {
    loadOrdersReducer, LoadOrdersAction,
    sortOrdersReducer, SortOrderAction,
    applySelectColumnsReducer, ApplySelectColumnsAction, loadPagination,
    setActiveTab, updateOrderTabsReducer, updateOrderReferenceReducer
} from './load-orders';
import { loadOrderDetailsReducer, LoadOrderDetailsAction } from './load-order-details';
import { putServiceReferenceIntReducer } from './put-service-reference-int';
import {
    resetOrderInfoReducer, OrderInfoResetAction,
    loadOrderInfoReducer, LoadOrderInfoAction,
    updateSelectedProductReducer,
    UpdateSelectedProductAction,
    UpdateSelectedProductTempAction,
    updateSelectedProductTempReducer,
    updateDetailsViewByReducer,
    DetailUpdateViewBySuccessAction,

} from './load-order-info';
import {
    updateAcceptanceStatusTempReducer

} from './update-acceptance-status';
import {
    updateOrderSuccessReducer, updateOrderDetailsSummaryFilterSuccess,
    searchOrdersAction, searchOrderDetailsSummarySuccessReducer
} from './load-search-orders';
import { loadSummaryReducer, LoadSummaryAction } from './load-summary';
import { downloadCSVReducer, IDownloadCSVFileAction } from './download-order-summary';
import { LoadOrderExpressAction, loadOrderExpressReducer } from './load-order-express';
import { LoadAppointmentAction, loadAppointmentDateReducer } from './load-appointment-date';
import { loadOrderProductDetailsReducer } from './load-order-product-details';
import { loadOrdersIntV2Reducer, updateOrderListFilterV2 } from './order-tracker-int-uplift/load-orders-new';
import { updateOrderIntV2SuccessReducer } from './order-tracker-int-uplift/load-search-orders-new';
import { updateOrderReferenceLocallyReducer } from './order-tracker-int-uplift/update-order-reference-locally-int-new';
import { DownloadProductListAction, downloadProductListReducer } from './download-product-list';
import { LoadProductOrderListAction, loadProductOrderListReducer } from './product-order-list';

export type OrderTrackerAction =
    LoadOrdersAction |
    LoadOrderDetailsAction |
    LoadOrderInfoAction |
    OrderInfoResetAction |
    searchOrdersAction |
    LoadSummaryAction |
    SortOrderAction |
    UpdateSelectedProductAction |
    UpdateSelectedProductTempAction |
    IDownloadCSVFileAction |
    DetailUpdateViewBySuccessAction |
    SortOrderAction |
    ApplySelectColumnsAction |
    LoadOrderExpressAction |
    LoadAppointmentAction |
    DownloadProductListAction |
    LoadProductOrderListAction

const reducersMap: IReducersMap<IOrderTrackerState> = {
    [ORDER_TRACKER_LOAD_ORDERS]: loadOrdersReducer,
    [ORDER_TRACKER_SORT_ORDERS]: sortOrdersReducer,
    [ORDER_TRACKER_LOAD_ORDER_DETAILS]: loadOrderDetailsReducer,
    [ORDER_TRACKER_LOAD_ORDER_INFO]: loadOrderInfoReducer,
    [ORDER_TRACKER_LOAD_ORDER_PRODUCT_DETAILS]: loadOrderProductDetailsReducer,
    [ORDER_TRACKER_LOAD_ORDER_INFO_RESET]: resetOrderInfoReducer,
    [ORDER_TRACKER_UPDATE_SEARCH_ORDERS]: updateOrderSuccessReducer,
    [ORDER_TRACKER_UPDATE_SEARCH_ORDER_DETAILS_SUMMARY]: updateOrderDetailsSummaryFilterSuccess,
    [ORDER_TRACKER_SEARCH_ORDER_DETAILS_SUMMARY]: searchOrderDetailsSummarySuccessReducer,
    [ORDER_TRACKER_UPDATE_SELECTED_PRODUCT]: updateSelectedProductReducer,
    [ORDER_TRACKER_UPDATE_SELECTED_PRODUCT_TEMP]: updateSelectedProductTempReducer,
    [ORDER_TRACKER_LOAD_SUMMARY]: loadSummaryReducer,
    [ORDER_TRACKER_LOAD_PAGINATION]: loadPagination,
    [ORDER_TRACKER_DOWNLOAD_CSV]: downloadCSVReducer,
    [ORDER_TRACKER_DETAIL_UPDATE_VIEW_BY]: updateDetailsViewByReducer,
    [ORDER_TRACKER_SELECT_COLUMNS]: applySelectColumnsReducer,
    [ORDER_TRACKER_ORDER_EXPRESS_FLAG]: loadOrderExpressReducer,
    [ORDER_TRACKER_ACTIVE_TAB]: setActiveTab,
    [ORDER_TRACKER_UPDATE_ORDER_TABS]: updateOrderTabsReducer,
    [ORDER_TRACKER_UPDATE_ORDER_REFERENCE]: updateOrderReferenceReducer,
    [ORDER_TRACKER_DETAIL_UPDATE_ACCEPTANCE_STATUS]: updateAcceptanceStatusTempReducer,
    [ORDER_TRACKER_LOAD_APPOINTMENT_DATE]: loadAppointmentDateReducer,
    [SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE_INT]: putServiceReferenceIntReducer,
    [ORDER_TRACKER_LOAD_ORDERS_INT_V2]: loadOrdersIntV2Reducer,
    [ORDER_TRACKER_UPDATE_ORDER_REFERENCE_LOCALLY]: updateOrderReferenceLocallyReducer,
    [ORDER_TRACKER_INT_LIST_UPDATE]: updateOrderListFilterV2,
    [ORDER_TRACKER_UPDATE_SEARCH_ORDERS_INT_V2]: updateOrderIntV2SuccessReducer,
    [ORDER_TRACKER_DOWNLOAD_PRODUCT_LIST]: downloadProductListReducer,
    [ORDER_TRACKER_PRODUCT_ORDERS_LIST]: loadProductOrderListReducer
};

export const trackerReducer = reducer<IOrderTrackerState, OrderTrackerAction>
    (reducersMap, initialState);
